import { useState, useCallback } from 'react';
import _ from 'lodash';
import FormControlLabel from '../../../../global/Mui/FormControlLabel';
import Checkbox from '../../../../global/Mui/Checkbox';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import {
  RECYCLING_PRODUCT_ITEMS,
} from '../../../../utils/tbbRegistration';
import NotAllowedDevices from '../../Components/NotAllowedDevices/NotAllowedDevices';

import './RecyclingList.scss';

const advice = 'Find out which devices can’t be shipped';

const RecyclingList = ({
  stepTrackerProps,
  onSubmit,
  isVirtualBox,
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = useCallback((event) => {
    const { name, checked } = event.target;
    if (checked) {
      setSelectedItems([...selectedItems, name]);
    } else {
      setSelectedItems(selectedItems.filter((item) => item !== name));
    }
  }, [selectedItems]);

  return (
    <div className="RecyclingList">
      <div className="RecyclingList__container">
        <div className="RecyclingList__container--title">
          {isVirtualBox ? 'WHAT\'S GOING IN YOUR BOX?' : 'What are you recycling?'}
        </div>
        <div className="RecyclingList__container--content">
          <div className="RecyclingList__container--content--itemsList">
            {
            RECYCLING_PRODUCT_ITEMS.map((item) => (
              <div className="RecyclingList__container--content--itemsList--item">
                <FormControlLabel
                  label={item.label}
                  control={(
                    <Checkbox
                      name={item.label}
                      checkedColor="#2649D4 !important"
                      onChange={handleCheckboxChange}
                    />
                )}
                />
              </div>
            ))
          }
          </div>

          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            disabled={_.isEmpty(selectedItems)}
            onClick={() => onSubmit()}
            trackerProps={stepTrackerProps}
          >
            continue
          </Button>

          <div className="RecyclingList__container--content--message">
            {advice}
            <Button
              type={BUTTON_TYPE.LINK_QUATERNARY}
              size={BUTTON_SIZE.SMALL}
              onClick={() => setShowDialog(true)}
            >
              view list
            </Button>
          </div>

        </div>
      </div>
      <NotAllowedDevices
        open={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </div>
  );
};

export default RecyclingList;
